/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ApplicationError } from '../model/application-error.model';
import { CoreErrorKey } from '../key/core-error.key';
import { ResourcesProvider } from '../provider/resources.provider';
import { ResourceEntry } from '../model/resource-entry.model';

export class ResourceService {

  getResource(key: string): string {
    if (!key) {
      return null;
    }
    const keySegments: string[] = key.split('/');
    let resource: ResourceEntry = ResourcesProvider.resolveResources(keySegments[0]);
    for (let i = 1; i < keySegments.length; i++) {
      if (!resource) {
        return null;
      }
      const keySegment = keySegments[i];
      if (typeof resource !== 'object' || !keySegment) {
        throw new ApplicationError({
          key: CoreErrorKey.RESOURCE_KEY_INVALID,
          arguments: { key },
          message: `Key '${key}' invalid`
        });
      }
      resource = resource[keySegment];
    }
    if (typeof resource === 'string') {
      return resource;
    }
    if (!resource) {
      return null;
    }
    throw new ApplicationError({
      key: CoreErrorKey.RESOURCE_KEY_INCOMPLETE,
      arguments: { key },
      message: `Key '${key}' incomplete`
    });
  }

}
